export  const formatCurrency = (x: number) : string => {
    if (typeof x === 'string') {
        return formatCurrency(parseInt(x));
    }
    return x ? x.toFixed(0).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ".") : "0";
}